import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

const ROUTE = process.env.VUE_APP_SHOP_V2_BASE_URI
const ENTITY = 'tax-jurisdictions'

export default abstract class TaxJurisdictionsApi {
  public static baseRoute = `${ROUTE}/${ENTITY}`

  public static async list(params: string): Promise<AxiosResponse> {
    return await axios.get(`${this.baseRoute}?${params}`)
  }

  public static async getArenaTaxJurisdiction(
    arenaId: string,
  ): Promise<AxiosResponse> {
    return await axios.get(`${ROUTE}/arenas/${arenaId}/tax-jurisdiction`)
  }
}
